import React, { useEffect, useState } from "react";

export const useOnlyFirstRender = (callback, dependencies) => {
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    if (firstRender) {
      callback();
    } else {
      //// first render to be false to use hook run callback only one time
      setFirstRender(false);
    }
  }, [...dependencies]);
};
